import {
  validateFlightNumber,
  validatePhoneNumber,
} from '@/core/lib/utils/validators'
import { TranslationFunction } from '@/i18n/types'
import * as z from 'zod'

export const getCreateTripValidation = (
  t: TranslationFunction,
  { isAirport, isUpdate }: { isAirport: boolean; isUpdate: boolean },
) => {
  const schema = z.object({
    email: z
      .string()
      .min(1, { message: t('validation.emailReq') })
      .email({ message: t('validation.emailErr') }),
    flightNumber: isAirport
      ? z
          .string()
          .min(1, {
            message: t('validation.flightReq'),
          })
          .refine(validateFlightNumber, {
            message: t('validation.flightErr'),
          })
      : z
          .string()
          .refine(validateFlightNumber, {
            message: t('validation.flightErr'),
          })
          .or(z.literal(''))
          .or(z.literal(null)),
    phoneNumber: z
      .string()
      .min(1, {
        message: t('validation.phoneReq'),
      })
      .refine(validatePhoneNumber, {
        message: t('validation.phoneErr'),
      }),
    fullName: isUpdate
      ? z.string().or(z.literal('')).optional()
      : z.string().trim().min(3, t('validation.nameErr')),
    noPassengerEmail: z.boolean().optional(),
    pickupTime: z.string(),
    note: z.string().optional(),
    relationWithPassenger: z.string().optional(),
    vehicleSizeId: z.string(),
    tripFor: z.string(),
    waitingTime: z.number(),
  })

  return { schema }
}
